import React from "react";
import { getDisabledStateFromLifecycleStatuses } from "../../utilities/lifecycleStatus";
import {
	IconArchive,
	IconArchiveOff,
	IconTrashOff,
	IconTrashX,
} from "@tabler/icons-react";
import { makeAdminDetailsMenuItem } from "../Admin/AdminDetailsMenuItem";

const NoteContextMenu = ({
	note,
	permissions,
	callbacks,
	location,
	isLexworkplaceAdmin,
	tenantID,
}) => {
	const { id, matterNoteLifecycleStatus } = note;

	const noteLifecycleStatusObject = getDisabledStateFromLifecycleStatuses({
		matterNoteLifecycleStatus,
	});

	const { matterOrFolderLifecycleStatusObject, archiveAccess } = permissions;

	const { onDelete, onRestore, onArchive, onUnarchive } = callbacks;

	const { matterID, apiBasepath, root } = location;

	const parentDisabled = matterOrFolderLifecycleStatusObject.disabled;
	const parentDisabledText = matterOrFolderLifecycleStatusObject.disabledText;
	const noteArchiveAccess = archiveAccess
		? noteLifecycleStatusObject.IN_ARCHIVE
			? archiveAccess.unarchive
			: archiveAccess.archive
		: null;

	const menuItems = [
		isLexworkplaceAdmin
			? makeAdminDetailsMenuItem(`/admin/tenant/${tenantID}/notes/${id}`)
			: null,
		{ sectionHeader: true, text: "Archive + Trash" },
		onArchive || onUnarchive
			? noteLifecycleStatusObject.IN_ARCHIVE
				? {
						text: "Unarchive Note",
						disabled: parentDisabled || noteArchiveAccess.disabled,
						disabledHoverText: parentDisabled
							? parentDisabledText
							: noteArchiveAccess.disabled
								? noteArchiveAccess.disabledText
								: "",
						onSelect: () =>
							onUnarchive([id], matterID, apiBasepath, root),
						iconComponent: (
							<IconArchiveOff
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						),
					}
				: {
						text: "Archive Note",
						disabled: parentDisabled || noteArchiveAccess.disabled,
						disabledHoverText: parentDisabled
							? parentDisabledText
							: noteArchiveAccess.disabled
								? noteArchiveAccess.disabledText
								: "",
						onSelect: () =>
							onArchive([id], matterID, apiBasepath, root),
						iconComponent: (
							<IconArchive
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						),
					}
			: null,
		noteLifecycleStatusObject.IN_TRASH
			? {
					text: "Restore Note from Trash Bin",
					disabled: parentDisabled,
					disabledHoverText: parentDisabled ? parentDisabledText : "",
					onSelect: () =>
						onRestore([id], matterID, apiBasepath, root),
					iconComponent: (
						<IconTrashOff
							size={16}
							style={{ verticalAlign: "sub" }}
						/>
					),
				}
			: {
					text: "Move Note to Trash Bin",
					disabled:
						!!parentDisabled ||
						!!(
							noteLifecycleStatusObject.IN_ARCHIVE &&
							noteArchiveAccess?.disabled
						),
					disabledHoverText: parentDisabled
						? parentDisabledText
						: noteLifecycleStatusObject.IN_ARCHIVE &&
							  noteArchiveAccess?.disabled
							? noteArchiveAccess.disabledText
							: "",
					onSelect: () => onDelete([id], matterID, apiBasepath, root),
					iconComponent: (
						<IconTrashX
							size={16}
							style={{ verticalAlign: "sub" }}
						/>
					),
				},
	].filter(Boolean);

	return menuItems;
};

export default NoteContextMenu;
